
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","stroke":"none !important","fill":"none !important","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 2v12h2V0H6v2h12z","stroke":"none"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 6v14h14V6H0zm12 2H2v10h10V8z","stroke":"none"}}),_c('path',{attrs:{"d":"M15 5H3V3h14v14h-2V5z","stroke":"none"}})])
          )
        }
      }
    